import { RETAILER } from 'constants/roles';
import { useAuthStore } from 'stores/authStore';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const selectProfile = (user) => {
  useAuthStore.getState().setUser(user);

  const { selectedBrandUid, selectedRegionUid, setSelectedProfile, clearSelectedProfile } =
    useSelectedProfileStore.getState();
  const { role } = useAuthStore.getState();

  const profiles = role === RETAILER ? getRetailerProfiles(user) : getAdminProfiles(user);
  const profile =
    profiles.find((p) => p.brandUid === selectedBrandUid && p.regionUid === selectedRegionUid) ||
    profiles[0];

  if (profile) {
    setSelectedProfile(profile);
  } else {
    clearSelectedProfile();
  }

  return user;
};

const getRetailerProfiles = (user) => {
  const profiles = user.profiles || [];
  return profiles.map((profile) => ({
    brandUid: profile.brand.uid,
    regionUid: profile.region.uid,
  }));
};

const getAdminProfiles = (user) => {
  const brand = user.admin_details?.brand;
  const regions = brand?.regions || [];
  return regions.map((region) => ({ brandUid: brand.uid, regionUid: region.uid }));
};
